import {Injectable} from '@angular/core';
import {SiteDto} from '../_services/configuration-services';

@Injectable({
    providedIn: 'root'
})
export class SiteUtils {

    public static siteName(site: SiteDto, lang: string): string {
        const namesByLang: Record<string, string | undefined> = {
            fr: site.nameFR,
            de: site.nameDE,
            en: site.nameEN,
            it: site.nameIT
        };

        return namesByLang[lang] ?? site.nameFR;
    }

    public static siteDescription(site: SiteDto, lang: string): string | undefined {
        const descriptionsByLang: Record<string, string | undefined> = {
            fr: site.descriptionFR,
            de: site.descriptionDE,
            en: site.descriptionEN,
            it: site.descriptionIT
        };

        return descriptionsByLang[lang] ?? site.descriptionFR;
    }

    public static sortByName(sites: SiteDto[], lang: string): SiteDto[] {
        return [...sites].sort((a, b) => SiteUtils.siteName(a, lang).localeCompare(SiteUtils.siteName(b, lang)));
    }
}
